import { useEffect } from "react";
import { BarChart3, X } from "lucide-react";
import "./analytics-consent.css";

export function AnalyticsConsent({ open = false, onClose }: { open?: boolean; onClose?: () => void }) {
  useEffect(() => {
    if (!open) return;
    const closeWithEscape = (event: KeyboardEvent) => { if (event.key === "Escape") onClose?.(); };
    window.addEventListener("keydown", closeWithEscape);
    return () => window.removeEventListener("keydown", closeWithEscape);
  }, [open, onClose]);
  if (!open) return null;
  return <section className="analytics-consent" role="region" aria-labelledby="analytics-consent-title">
    <div className="analytics-consent-copy"><BarChart3 size={21} aria-hidden="true" /><div>
      <h2 id="analytics-consent-title">Come misuriamo il sito</h2>
      <p>GRUVO usa conteggi complessivi di accessi, pagine consultate e brevi intervalli di tempo con la pagina visibile e attiva. Le statistiche non contengono nomi, indirizzi e-mail, ricerche o identificativi dei visitatori e non collegano le tue visite tra loro.</p>
      <p className="analytics-consent-detail">Nessun cookie statistico e nessuna pubblicità personalizzata. Accessi e visualizzazioni non sono persone uniche; il tempo medio è indicativo. <a href="#/legal" onClick={onClose}>Leggi l’informativa privacy</a></p>
      <p className="analytics-consent-detail">I venditori vedono soltanto quanti salvataggi e visualizzazioni ha un annuncio, non chi lo abbia salvato o visitato.</p>
    </div></div>
    <div className="analytics-consent-actions"><button type="button" className="analytics-consent-button" onClick={onClose}>Ho capito</button></div>
    <button type="button" className="analytics-consent-close" aria-label="Chiudi l’informativa sulle statistiche" onClick={onClose}><X size={19} /></button>
  </section>;
}

export default AnalyticsConsent;
